<template>
  <div class="mt-4">
    <div class="my-3">
      <button class="btn btn-link pl-0" @click="back">
        <i class="fas fa-angle-left"></i> Back to Summary
      </button>
    </div>

    <!-- filters -->
    <CompetitionDetailsFilters class="mb-4" @filtersApplied="refreshDetails" :key="refreshKey" />

    <!-- details -->
    <CompetitionDetails :loading="loading" :wcLoading="wcLoading" @refreshDetails="refreshKey++" />
  </div>
</template>

<script>
import CompetitionDetails from './CompetitionDetails.vue'
import CompetitionDetailsFilters from './CompetitionDetailsFilters.vue'
import { createNamespacedHelpers } from 'vuex'

const CompetitionModule = createNamespacedHelpers('competition')
const CompetitionDetailsModule = createNamespacedHelpers('competitionDetails')

export default {
  name: 'CompetitionDetailsView',
  components: {
    CompetitionDetails,
    CompetitionDetailsFilters
  },
  data: () => ({
    loading: true,
    wcLoading: true,
    refreshKey: 0
  }),
  mounted() {
    window.scrollTo(0, 0)
  },
  computed: {
    ...CompetitionModule.mapGetters(['selectLastSummaryURL'])
  },
  methods: {
    ...CompetitionDetailsModule.mapActions([
      'fetchFeedbackData',
      'fetchBreakdown',
      'fetchSummaries'
    ]),
    back() {
      this.$router.push(this.selectLastSummaryURL)
    },
    refreshDetails() {
      this.loadBasic()
      this.loadSummaries()
    },
    async loadBasic() {
      this.loading = true
      await Promise.all([this.fetchFeedbackData(), this.fetchBreakdown()])
      this.loading = false
    },
    async loadSummaries() {
      this.wcLoading = true
      await this.fetchSummaries()
      this.wcLoading = false
    }
  }
}
</script>
